<ng-container *ngIf="!readonly">
  <mat-slide-toggle
    [attr.data-automation-id]="dataAutomationId"
    [formControl]="formControl"
    color="primary"
    [required]="fgInfo.required"
  >
  {{ labelOverride || fgInfo?.label }}{{ formControl['condrequired'] || fgInfo?.required ? '*' : '' }}
  </mat-slide-toggle>
  <div class="checkbox-error mat-hint" *ngIf="hint && (!formControl.touched || formControl.valid)">
    {{ hint }}
  </div>
  <div class="checkbox-error mat-error" *ngFor="let errorDefinition of errorDefinitions">
    <ng-container *ngIf="formControl.touched && errorDefinition.showFunction()">
      {{ errorDefinition.errorMessage(formControl) }}
    </ng-container>
  </div>
</ng-container>
<ng-container *ngIf="readonly">
  <mat-form-field
    class="no-underline w-100"
    [ngClass]="{ 'read-only': readonly }"
    [floatLabel]="'always'"
  >
    <mat-label>{{ labelOverride || fgInfo?.label }}</mat-label>
    <input
      readonly
      matInput
      [attr.data-automation-id]="dataAutomationId"
      [value]="formControl.value == true ? 'Yes' : 'No'"
      tabindex="-1"
    />
  </mat-form-field>
</ng-container>
